import { Channel } from '../enums/channel.enum';

/**
 * The "Phone" option of the Channel filter is keyed on MOBILE (so saved filters keep working)
 * but phone orders are tagged either MOBILE or TELE.
 */
export const PHONE_CHANNEL_CODES: string[] = [Channel.Mobile, Channel.Tele];

/**
 * Expands a channel argument so that selecting Phone (MOBILE) also selects TELE.
 * Accepts "MOBILE", "(MOBILE)", "POS,MOBILE" or an array. The parenthesised form is preserved.
 * Idempotent; arguments without MOBILE are returned untouched.
 */
export function expandChannelArgument(argument: string): string;
export function expandChannelArgument(argument: string[]): string[];
export function expandChannelArgument(argument: string | string[]): string | string[] {
  if (!argument) {
    return argument;
  }
  const isArray = Array.isArray(argument);
  const raw = isArray ? (argument as string[]).join(',') : (argument as string);
  const hasParentheses = raw.trim().startsWith('(') && raw.trim().endsWith(')');
  const values = raw
    .replace(/[()]/g, '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

  if (!values.includes(Channel.Mobile) || values.includes(Channel.Tele)) {
    return argument;
  }
  const expanded = [...values, Channel.Tele];
  if (isArray) {
    return expanded;
  }
  const joined = expanded.join(',');
  return hasParentheses ? `(${joined})` : joined;
}

/**
 * Inverse of expandChannelArgument, used when a saved criteria is loaded back into the UI so that
 * Phone shows up as a single selection.
 */
export function collapseChannelArgument(values: string[]): string[] {
  if (!values?.includes(Channel.Mobile)) {
    return values;
  }
  return values.filter((value) => value !== Channel.Tele);
}
